import React, { useContext, useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { ServiceManager } from '@jutro/services';
import { PhoneNumber } from 'gw-components-platform-react';
import {
    Button,
    InputField,
    Icon,
    Link,
    Chevron,
    IconButton,
    ModalNextProvider
} from '@jutro/components';
import { useValidation } from 'gw-portals-validation-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { fnolCommonMessages, VehicleDamagePicker } from 'gw-capability-fnol-common-react';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import messages from '../../FNOLCA.messages';
import metadata from './VehiclePassengers.metadata.json5';
import caClaimStyles from './VehiclesPage.module.scss';
import CAClaimExtension from "../../../nexus-capability-fnol-common-react/models/CAClaimExtension";
import FNOLCAContactItemComponent from "../../components/CAContactItemComponent/CAContactItemComponent";

function FNOLCAVehiclePassengersPage(props) {
    const localeService = ServiceManager.getService('locale-service');
    const translator = useContext(TranslatorContext);
    const { vehicleIncidentVM, claimVM, onValidate, id, updateWizardData, updateIncidentChanges, incidentIndex } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    /*const getAddPassengerDescValue = useCallback(
        (item, index, property) => {
            let [vehicleIncidentIndex] = (property.path || '').match(/\d+/g) || [];
            vehicleIncidentIndex = Number(vehicleIncidentIndex);
            personIndex = Number(personIndex);
            const passengerContactPath = `passengers.value[${personIndex}]`;
            return _.get(vehicleIncidentVM, `${passengerContactPath}.injuryDescription.value`);
        },
        [claimVM]
    );*/

    const getIsPersonInjuredValue = useCallback(
        (personIndex, path) => {
            const passengerContactPath = `passengers.value[${personIndex}]`;
            const passengerContact = _.get(vehicleIncidentVM, passengerContactPath);
            const injuredIncident = claimVM.lobs.commercialAuto.value.findInjuryIncidentByContact(passengerContact);
            if (injuredIncident) {
                return true;
            } else {
                return false;
            }
        },
        [claimVM]
    );

    const updatePersonInjuredValue = useCallback(
        (value, index) => {
            const vehicleIncident = vehicleIncidentVM.value;
            const passengerContactPath = `passengers.value[${index}]`;
            const passengerContact = _.get(vehicleIncidentVM, passengerContactPath);
            const injuredIncident = claimVM.lobs.commercialAuto.value.findInjuryIncidentByContact(passengerContact);
            if (value && !injuredIncident) {
                claimVM.lobs.commercialAuto.value.addInjuryIncident(passengerContact, vehicleIncident.lossParty);
            } else {
                claimVM.lobs.commercialAuto.value.removeInjuryIncident(injuredIncident);
            }
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const getPersonInjuredDescValue = useCallback(
        (index) => {
            const passengerContactPath = `passengers.value[${index}]`;
            const passengerContact = _.get(vehicleIncidentVM, passengerContactPath);
            var injuredIncidentIndex = claimVM.lobs.commercialAuto.value.findInjuryIncidentIndexByContact(passengerContact);
            const injuredIncidentPath = `lobs.commercialAuto.injuryIncidents.value[${injuredIncidentIndex}]`;
            return _.get(claimVM, `${injuredIncidentPath}.description`);
        },
        [claimVM]
    );

    const updatePersonInjuredDescValue = useCallback(
        (value, index) => {
            const passengerContactPath = `passengers.value[${index}]`;
            const passengerContact = _.get(vehicleIncidentVM, passengerContactPath);
            var injuredIncidentIndex = claimVM.lobs.commercialAuto.value.findInjuryIncidentIndexByContact(passengerContact);
            if (value && injuredIncidentIndex !== -1) {
                const injuredIncidentPath = `lobs.commercialAuto.injuryIncidents.value[${injuredIncidentIndex}]`;
                _.set(claimVM, `${injuredIncidentPath}.description`, value);
            }
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const generatePassengerTableRow = useCallback(
        (evt, incidentIndex, index) => {
            evt.preventDefault();
            const getCurrentMenuItemID = evt.currentTarget.id;
            const getCurrentMenuItemIDNew = getCurrentMenuItemID.split('_');
            const contactsPath = 'contacts.value';
            const contactsItems = _.get(claimVM, contactsPath, []);
            if (getCurrentMenuItemIDNew[0].indexOf('anotherPersonLink') === -1) {
                const selectedPassenger = contactsItems[index];
                if (_.filter(contactsItems, selectedPassenger).length) {
                    claimVM.lobs.commercialAuto.vehicleIncidents.value[incidentIndex].addPassenger(
                        selectedPassenger,
                        claimVM.value
                    );
                }
            } else {
                claimVM.lobs.commercialAuto.vehicleIncidents.value[incidentIndex].addPassenger(
                    null,
                    claimVM.value
                );
            }
            const newClaimVM = _.clone(claimVM);
            updateWizardData(newClaimVM);
        },
        [claimVM, updateWizardData]
    );

    const renderTriggerAddPerson = useCallback(
        (dropDownProps, toggleMenu) => {
            const { isOpen } = dropDownProps;
            const onAddPersonClick = () => {
                toggleMenu(!isOpen);
            };
            return (
                <Button onClick={onAddPersonClick} icon="mi-expand-more" iconPosition="right">
                    {translator(messages.caAddPassenger)}
                </Button>
            );
        },
        [translator]
    );


    /*const updatePersonInjuredValueCallBack = useCallback(
        (value, path, vehicleIncidentIndexs) => {
            let [personIndex] = path.match(/\d+/g);
            personIndex = Number(personIndex);
            const vehicleIncident = vehicleIncidentVM.value;
            const passengerContactPath = `passengers.value[${personIndex}]`;
            const passengerContact = _.get(vehicleIncidentVM, passengerContactPath);
            var injuredIncidentIndex = claimVM.lobs.commercialAuto.value.findInjuryIncidentIndexByContact(passengerContact);
            if (value && injuredIncidentIndex !== -1) {
                const injuredIncidentPath = `lobs.commercialAuto.injuryIncidents.value[${injuredIncidentIndex}]`;
                _.set(claimVM, `${injuredIncidentPath}.description`, value);
                _.set(vehicleIncidentVM, `${passengerContactPath}.injuryDescription`, value);
            }
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );*/

    const updateIsPersonInjuredValue = useCallback(
        (value, path, evet) => {

            let [personIndex] = path.match(/\d+/g);
            personIndex = Number(personIndex);
            const vehicleIncident = vehicleIncidentVM.value;
            const passengerContactPath = `passengers.value[${personIndex}]`;
            const passengerContact = _.get(vehicleIncidentVM, passengerContactPath);
            if (value) {
                claimVM.lobs.commercialAuto.value.addInjuryIncident(passengerContact, vehicleIncident.lossParty);
            } else {
                const injuredIncident = claimVM.lobs.commercialAuto.value.findInjuryIncidentByContact(passengerContact);
                claimVM.lobs.commercialAuto.value.removeInjuryIncident(injuredIncident);
                _.set(vehicleIncidentVM, `${passengerContactPath}.injuryDescription`, null);
            }
            _.set(vehicleIncidentVM, path, value);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const removePassengerFromIncident= useCallback(
        (evt) => {
            //const incidentIndex = /\d+/.exec(evt.path)[0];
            const newClaimVM = _.clone(claimVM);
            const [deletedPerson] = vehicleIncidentVM.value.passengers.splice(
                evt.index,
                1
            );
            if (deletedPerson.tempID && !deletedPerson.publicID) {
                const conactToRemoveIndex = newClaimVM.contacts.value.findIndex(ele => ele.tempID === deletedPerson.tempID);
                newClaimVM.contacts.value.splice(
                    conactToRemoveIndex, 1);
            }
            updateWizardData(newClaimVM);
        },
        [claimVM, updateWizardData]
    );

    const onModelChange = (updatedVM) => {
        //const newVehicleIncidentVM = viewModelService.clone(updatedVM);
        //updateIncidentChanges(updatedVM.value);
        updateWizardData(claimVM);
    }

    const generatePassengersOverrideProps = useCallback(() => {
        let overrideProps = {
            caAddPassengerTable: {
                data: vehicleIncidentVM.value.passengers,
                visible: !_.isEmpty(vehicleIncidentVM.value.passengers)
            },
            addPassengerTableContainer: {
                data: vehicleIncidentVM.value.passengers,
                visible: !_.isEmpty(vehicleIncidentVM.value.passengers)
            },
            caPassengersAddPassenger: {
                renderTrigger: renderTriggerAddPerson
            },
            addPersonDropDownItems: {
                data: claimVM,
                incidentIndex: incidentIndex,
                updateAddPassengers: updateWizardData
            },
            anotherPersonLink: {
                onClick: (e) => {
                    generatePassengerTableRow(e, incidentIndex);
                }
            },
        };
        if (vehicleIncidentVM.value.passengers) {
            const overrides = vehicleIncidentVM.value.passengers.map((passenger, index) => {
                return {
                    [`addPassengerHeaderCount${index}`]: {
                        content: translator(messages.caPassenger) + (index + 1)
                    },
                    [`caAddPassengerTablePersonInjured${index}`]: {
                        value: getIsPersonInjuredValue(index),
                        onValueChange: (value, path) => {
                            updatePersonInjuredValue(value, index);
                        }
                    },
                    [`caAddPassengerTableDamageDescription${index}`]: {
                        visible: getIsPersonInjuredValue(index),
                        required: true,
                        value: getPersonInjuredDescValue(index),
                        onValueChange: (value, path) => {
                            updatePersonInjuredDescValue(value, index);
                        }
                    }
                };
            });
            return Object.assign(overrideProps, ...overrides);
        }
        return Object.assign(overrideProps);
    }, [claimVM, updateWizardData]);

    const overrides = {
        '@field': {
            showOptional: false,
            showRequired: true
        },

        ...generatePassengersOverrideProps()

    };

    const resolvers = {
        resolveClassNameMap: caClaimStyles,
        resolveComponentMap: {
            contactitemcomponent: FNOLCAContactItemComponent,
        },
        resolveCallbackMap: {
            //updatePersonInjuredValueCallBack: updatePersonInjuredValueCallBack,
            //getAddPassengerDescValue: getAddPassengerDescValue,
            updateIsPersonInjuredValue: updateIsPersonInjuredValue,
            removePassengerFromIncidentRow: removePassengerFromIncident
        }
    };

    return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                model={vehicleIncidentVM}
                onModelChange={onModelChange}
            />
    );
}

FNOLCAVehiclePassengersPage.propTypes = {
    vehicleIncidentVM: PropTypes.object,
    incidentIndex: PropTypes.number.isRequired,
    claimVM: PropTypes.object,
    updateWizardData: PropTypes.func,
    updateIncidentChanges: PropTypes.func
};

FNOLCAVehiclePassengersPage.propTypes = wizardProps;
export default withRouter(FNOLCAVehiclePassengersPage);